module.exports = __webpack_public_path__ + "img/戚务生@2x.748a4184.png";